import React, { useMemo, useState } from 'react';
import DynamicWidget from '@components/widgets/dynamic-display/DynamicWidget';
import { IBPGeneralData, IBusinessPartnerInfo } from '../../..';
import EnhancedButton from '@components/button/EnhancedButton';
import { maxCreditLimitView } from './content';
import MaxCreditLimitDrawer from './max-credit-limit-drawer/MaxCreditLimitDrawer';

interface IMaxCreditLimitDetailsWidgetProps {
  businessPartnerDetails: IBusinessPartnerInfo;
  generalData: IBPGeneralData;
  onSuccess: () => void;
}

const MaxCreditLimitDetailsWidget: React.FC<
  IMaxCreditLimitDetailsWidgetProps
> = ({ businessPartnerDetails, generalData, onSuccess }) => {
  const [isDrawerOpen, setIsDrawerOpen] = useState<boolean>();

  const view = useMemo(() => {
    return maxCreditLimitView(businessPartnerDetails);
  }, [businessPartnerDetails]);

  const actions = (
    <EnhancedButton
      type="button"
      isPrimary
      onClick={() => setIsDrawerOpen(true)}
    >
      Modify
    </EnhancedButton>
  );

  return (
    <>
      <DynamicWidget
        hasFourFields={true}
        view={view}
        actions={
          !generalData.businessPartner.isDirectSalesforce &&
          generalData.userIsAdmin &&
          actions
        }
      />
      {isDrawerOpen && (
        <MaxCreditLimitDrawer
          open={isDrawerOpen}
          onClose={() => setIsDrawerOpen(false)}
          onSuccess={() => {
            onSuccess();
          }}
          businessPartnerId={generalData.businessPartner.id}
          salesForceMaxCreditLimitDetailsInfo={businessPartnerDetails as any}
        />
      )}
    </>
  );
};

export default MaxCreditLimitDetailsWidget;
